import {Base64Object} from '@coolcolduk/util';
import {deleteField} from 'firebase/firestore';
import {useCallback} from 'react';
import updateUserDoc from '../../api/user/updateUserDoc';
import uploadUserBackgroundImage from '../../api/user/uploadUserBackgroundImage';
import {firebaseAuth} from '../../config/firebase';
import {useFunctionRun} from '../helper/function/useFunctionRun';

export default function useSetBackgroundImage() {
  const setBackgroundImageFn = useCallback(async (backgroundImage?: Base64Object): Promise<void> => {
    const uid = firebaseAuth.currentUser?.uid;
    if (!uid) throw new Error('Not authenticated');
    const backgroundImageUrl = await uploadUserBackgroundImage(uid, backgroundImage);
    await updateUserDoc(uid, {backgroundImageUrl: backgroundImageUrl ?? deleteField()});
  }, []);

  const {loading, error, refetch} = useFunctionRun(setBackgroundImageFn, {
    skipLoadOnMount: true,
  });

  return {setBackgroundImage: refetch, loading, error};
}
